import { render } from "./AppRouteLoader.vue?vue&type=template&id=162cacd8&scoped=true&ts=true"
import script from "./AppRouteLoader.vue?vue&type=script&lang=ts"
export * from "./AppRouteLoader.vue?vue&type=script&lang=ts"

import "./AppRouteLoader.vue?vue&type=style&index=0&id=162cacd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162cacd8"]])

export default __exports__